<h2 mat-dialog-title [innerHtml]="data.title"></h2>
<mat-dialog-content>
	<div>
		<mat-form-field class="dialog-field">
			<mat-label>Macro Name</mat-label>
			<input matInput [(ngModel)]="data.macro.phrase" placeholder='Type the command you’ll say after the word "Insert"'>
		</mat-form-field>
	</div>

	<div>
		<mat-form-field class="dialog-field">
			<mat-label>Note Section</mat-label>
			<mat-select cdkFocusInitial [(ngModel)]="data.macro.section" placeholder="Select where this macro will be inserted">
				@for (section of sections; track section) {
					<mat-option [value]="section.shortName">{{section.name}}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</div>

	<div>
		<mat-form-field class="dialog-field">
			<mat-label>Macro Content</mat-label>
			<textarea class="dialog-textarea" matInput [(ngModel)]="data.macro.substitution" placeholder="Type the text you want inserted into your note"></textarea>
		</mat-form-field>
	</div>

</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="cancelDialog()" >{{ data.cancel }}</button>
	<button mat-flat-button [mat-dialog-close]="data.macro" [disabled]="!hasAllValues()" cdkFocusInitial>{{ data.ok }}</button>
</mat-dialog-actions>
